// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__lV6uK","content":"styles_content__1dCjf","checkbox":"styles_checkbox__1QDNF","checkboxLabel":"styles_checkboxLabel__1solR"};